<template>
    <section class="cases-component">
        <div class="filter-section" v-if="industries.length > 0 || products.length > 0 || skills.length > 0 || materials.length > 0">
            <div class="filter-items">
                <div class="filter-item filter-item--mw" v-if="industries.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="industry" class="filter-item__select">
                        <option value="All">{{dictionaries.CaseIndustryOptionDefault}}</option>
                        <option :value="industry.Key" v-for="(industry, index) in industries" v-if="industry.Name" :key="industry.Key">{{industry.Name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="products.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="product" class="filter-item__select">
                        <option value="All">{{dictionaries.CaseProductOptionDefault}}</option>
                        <option :value="product.Key" v-for="(product, index) in products" v-if="product.Name" :key="product.Key">{{product.Name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="skills.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="skill" class="filter-item__select">
                        <option value="All">{{dictionaries.CaseSkillOptionDefault}}</option>
                        <option :value="skill.Key" v-for="(skill, index) in skills" v-if="skill.Name" :key="skill.Key">{{skill.Name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="materials.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="material" class="filter-item__select">
                        <option value="All">{{dictionaries.CaseMaterialOptionDefault}}</option>
                        <option :value="material.Key" v-for="(material, index) in materials" v-if="material.Name" :key="material.Key">{{material.Name}}</option>
                    </select>
                </div>
                <div class="filter-item">
                    <button type="button" class="filter-item__button" @click="resetFilter" :disabled="isLoading">{{dictionaries.CaseFilterReset}}</button>
                </div>
            </div>
        </div>
        <ul class="cases-component__cases" v-show="cases.length">
            <caseItem v-for="caseItem in cases" :caseItem="caseItem" :key="caseItem.Id"></caseItem>
        </ul>
        <div class="cases-component__no-cases" v-show="!cases.length && !isLoading">{{dictionaries.CaseNoResult}}</div>
        <div class="cases-component__load-more" v-show="hasMoreCasesToLoad">
            <a @click="getNextPage" :disabled="isLoading">{{dictionaries.CaseLoadMore}}</a>
        </div>
    </section>
</template>

<script>
    import CaseItem from "./components/caseItem.vue";
    import { bindRoute } from "./mixins/bindroute.js";

    const serviceUrl = "/umbraco/api/cases/getcases",
        defaultPage = 1,
        defaultIndustry = "All",
        defaultProduct = "All",
        defaultSkill = "All",
        defaultMaterial = "All";
    export default {
        name: "cases",
        components: {
            CaseItem
        },
        data() {
            return {
                dictionaries: [],
                industries: [],
                products: [],
                skills: [],
                materials: [],
                cases: [],
                pageSize: 6,
                totalCases: 0,
                isLoading: false
            };
        },
        created() {
            this.casesPageId = this.$parent.casesPageId;
            this.getInitialCases();
        },
        mixins: [
            bindRoute({
                page: defaultPage,
                industry: defaultIndustry,
                product: defaultProduct,
                skill: defaultSkill,
                material: defaultMaterial
            })
        ],
        methods: {
            getCases(amountToSkip, pageSize) {
                var vm = this,
                    languageCode = $("html").attr("lang");
                vm.toggleSpinner(true);
                var object = {
                    languageCode: languageCode,
                    amountToSkip: amountToSkip,
                    pageSize: pageSize
                };
                if (this.industry != defaultIndustry) {
                    object.industry = this.industry;
                }
                if (this.product != defaultProduct) {
                    object.product = this.product;
                }
                if (this.skill != defaultSkill) {
                    object.skill = this.skill;
                }
                if (this.material != defaultMaterial) {
                    object.material = this.material;
                }
                if (this.casesPageId) {
                    object.casesPageId = this.casesPageId;
                }
                $.get(serviceUrl, object, function (response) {
                    vm.dictionaries = response.Dictionaries;
                    vm.industries = response.Facets.Industries;
                    vm.products = response.Facets.Products;
                    vm.skills = response.Facets.Skills;
                    vm.materials = response.Facets.Materials;
                    vm.cases.push(...response.Items);
                    vm.totalCases = response.TotalItems;
                }).fail(function (error) {
                    console.log(error);
                }).always(function () {
                    vm.toggleSpinner(false);
                });
            },
            getNextPage() {
                if (!this.isLoading) {
                    this.page++;
                    this.getCases(this.pageSize * (this.page - 1), this.pageSize);
                }
            },
            getInitialCases() {
                // Get all cases up to, and including, the current page
                const initialPageSize = this.pageSize * this.page;
                this.getCases(0, initialPageSize);
            },
            toggleSpinner: function (isLoading) {
                this.isLoading = isLoading;
                if (isLoading) {
                    $("body").addClass("is-loading");
                } else {
                    $("body").removeClass("is-loading");
                }
            },
            filterChanged() {
                this.cases = [];
                this.totalCases = 0;
                this.page = defaultPage;
                this.getCases(0, this.pageSize);
            },
            resetFilter() {
                this.cases = [];
                this.totalCases = 0;
                this.page = defaultPage;
                this.industry = defaultIndustry;
                this.product = defaultProduct;
                this.skill = defaultSkill;
                this.material = defaultMaterial;
                this.getCases(0, this.pageSize);
            }
        },
        computed: {
            hasMoreCasesToLoad() {
                return this.totalCases !== 0 && this.cases.length < this.totalCases;
            }
        }
    };
</script>
